import { FaLock, FaLockOpen, FaXmark } from "react-icons/fa6";
import { FaStar } from "react-icons/fa";

import classes from "./Item.module.css";
import { observer } from "mobx-react-lite";
import SequenceScenario from "@/js/SequenceScenario";
import { RiCoinLine } from "react-icons/ri";



import Button from "@/components/shared/Button/Button";
import clsx from "clsx";

import FitHeight from "react-sdk/components/FitHeight"

// TODO : https://stackoverflow.com/questions/69888696/how-to-reasonably-animate-font-awesome-lock-icons

const Item = ({ item, isInBlock, removeItem }) => {
  function handleClick(e) {
    if ((item.open || item.done) && item.blockRef.interactive) SequenceScenario.playSequence("MainSequence", `dis_${item.id}`)
  }

  function handleClose(e) {
    if(removeItem) removeItem(item)
  }

  // item.status = "locked_open"

  return (
    <div
    className={clsx(
      classes.Item,
      classes[item.status],
      isInBlock ? classes.inBlock : classes.notInBlock,
      item.selected && classes.selected,
      item.active && classes.active
    )}
    >

      {item.locked &&
        <FaLock />
      // <div className={classes.icon}>
      //   </div>
        }

      {item.locked_open && <FaLockOpen />}

      {item.open && <div onClick={(e) => { handleClick(e) }} className={classes.open}>?</div>}

      {item.done &&
      <>
        <img onClick={(e) => { handleClick(e) }} src={item.image} alt={item.title} draggable={false} />

        {item.selected && !isInBlock &&
        <FitHeight HTMLelement="h1" initialFZ={30} height={60}>{item.title}</FitHeight>}

        {((!item.selected && !item.active) || !isInBlock) &&
        <div className={classes.cost} >
          {item.cost} <RiCoinLine />
        </div>}

        {item.selected && !isInBlock &&
        <Button onClick={(e) => handleClose(e)} className={classes.closeBtn} icon={<FaXmark />} />}
      </>}

      {/* {AppState.debugMode && <div className={classes.Debug}>{item.status}</div>} */}
    </div>
  )
}

export default observer(Item);